import { eqProps } from 'ramda';

export function diffObject<T = Record<string, unknown>>(oldObject: T, newObject: T): Partial<T> {
  const diff: Partial<T> = {} as Partial<T>;

  for (const prop in newObject) {
    if (!eqProps(prop, oldObject, newObject)) {
      diff[prop] = newObject[prop];
    }
  }
  return diff;
}
